<div class="orderheaderbox">
  <div class="hederboxright">
    <button
      [class.customerbutton]="order.currentActivePage === order.activePageEnum.Order"
      (click)="onOrderClick(); order.setActivePage(order.activePageEnum.Order)"
      class="orderbtn">
      <i class="icon-rule-f headericon"></i>
      <span class="headertext">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.Order" | translate }}</span>
    </button>
    <button
      *ngIf="order.currentSaleMethodNature && order.currentSaleMethodNature !== order.SaleMethodNature.Delivery"
      (click)="onSalonClick(); order.setActivePage(order.activePageEnum.Salon)"
      [class.customerbutton]="order.currentActivePage === order.activePageEnum.Salon"
      class="orderbtn">
      <i class="icon-vector-square headericon"></i>
      <span class="headertext">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.Table" | translate }}</span>
    </button>
    <button
      [class.customerbutton]="order.currentActivePage === order.activePageEnum.Customer"
      (click)="order.setActivePage(order.activePageEnum.Customer)"
      class="orderbtn">
      <i class="icon-group-o headericon"></i>
      <span class="headertext">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.Customer" | translate }}</span>
    </button>
    <div class="notification" *ngIf="order.printerQueue?.length > 0">
      <div class="badge scale-in-center">{{ order.printerQueue?.length }}</div>
      <ssg-menu icon="icon-print-o" class="ssgmenu notification--bell">
        <div *ngIf="order.printerQueue?.length > 0" class="menuitem">
          <div *ngFor="let print of order.printerQueue" class="titlemenu">
            <span class="warning"
              >{{ "ClientApp.FrontOffice.Order.OrderPage.Header.Printer" | translate }} {{ print.PrinterName }}
              {{ "ClientApp.FrontOffice.Order.OrderPage.Header.FromComputer" | translate }} {{ print.ComputerName }}
              <span *ngIf="print.BranchTitle"> {{ print.BranchTitle }} </span>
              {{ "ClientApp.FrontOffice.Order.OrderPage.Header.Number" | translate }} {{ print.Queue }}
              {{ "ClientApp.FrontOffice.Order.OrderPage.Header.UnprintedInvoice" | translate }}</span
            >
          </div>
          <div class="titlemenu">
            <button class="refresh-btn" (click)="PrinterQueue()">
              <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Header.Reload" | translate }}</span>
            </button>
          </div>
        </div>
      </ssg-menu>
    </div>

    <div class="order-online" *ngIf="(isMultiBranch || order.currentBranch?.HasOrderOnline) && order?.saleMethodBranch?.HasDelino">
      <button
        [class.customerbutton]="order.currentActivePage === order.activePageEnum.OnlineFactor"
        (click)="order.setActivePage(order.activePageEnum.OnlineFactor)"
        class="orderbtn">
        <i class="icon-group-o headericon"></i>
        <span class="headertext">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.OrdreOnline" | translate }}</span>
      </button>
      <span class="order-count" *ngIf="order.DelinoInvoiceCount">{{ order.DelinoInvoiceCount }}</span>
    </div>
    <div class="pos-scale" *ngIf="order.hasPosScale" (click)="order.posScaleService.checkConnection(); order.detectChanges()">
      <span>ترازو</span>
      <small [ngClass]="order.posScaleService.isConnected ? 'bg-success' : 'bg-danger'"></small>
    </div>
  </div>

  <div class="headerboxleft">
    <div class="headertext chevron" *ngIf="order.invoice.State == rowState.Modify">
      <i class="icon-text-box-outline"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Header.FactorCode" | translate }}</span>
      <span class="txt">:</span>
      <span>{{ this.order.invoice.Code }}</span>
      <span class="txt">,</span>
      <span class="txt">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.FactorDate" | translate }}-</span>
      <span>{{ this.order.invoice.ShamsiCreatedDate }}</span>
    </div>

    <div class="headertext chevron" *ngIf="order.currentActivePage !== order.activePageEnum.Customer">
      <i class="icon-text-box-outline"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Header.OldFactor" | translate }}</span>
      <span class="txt">:</span>
      <span>{{ this.order.invoice.LastInvoiceCode }}</span>
      <span class="txt">,</span>
      <span>{{ this.order.invoice.LastInvoiceAmount | number }}</span>
      <span class="txt">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.UnitPrice" | translate }}</span>
    </div>
    <button (click)="setDestinationPage(); order.newInvoice(); order.setInvoiceHasFactorAndHasPaymentLink()">
      <i class="icon-playlist_add-o"></i>
      <span class="headertext"> {{ "ClientApp.FrontOffice.Order.OrderPage.Header.New" | translate }}</span>
    </button>
    <button
      (click)="onInvoicesListClick(); order.setActivePage(order.activePageEnum.Invoices)"
      [class.customerbutton]="order.currentActivePage === order.activePageEnum.Invoices">
      <i class="icon-library_books-o"></i>
      <span class="headertext">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.Factors" | translate }}</span>
    </button>
    <button
      *ngIf="order.saleMethodBranch.HasOnlineRezerv"
      (click)="order.setActivePage(order.activePageEnum.ReserveOnline)"
      [class.customerbutton]="order.currentActivePage === order.activePageEnum.ReserveOnline">
      <i class="icon-library_books-o"></i>
      <span class="headertext">{{ "ClientApp.FrontOffice.Order.OrderPage.Header.ReserveOnline" | translate }}</span>
    </button>
  </div>
</div>
